/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

export enum AddressType {
  Registered = 'Registered address',
  Billing = 'Billing',
  Decision = 'Decision making unit',
  Delivery = 'Delivery',
  Main = 'Main',
  Pickup = 'Pickup',
  Shipping = 'Shipping',
  Warehouse = 'Warehouse',
  Invoicing = 'Invoicing',
  Correspondence = 'Correspondence address',
  FiscalResidence = 'FiscalResidence',
  Office = 'Office',
}
